module.exports = __webpack_public_path__ + "media/product/latest-deal-larg-50988a8c.png";